(function() {
  function toggleChatWindow() {
    var chatWindow = document.getElementById("manual-chat-window");
    var chatBtn = document.getElementById("manual-chat-btn");
    var body = document.body;
    var html = document.documentElement;
    
    if (!chatWindow || !chatBtn) return;
    
    var iframe = chatWindow.querySelector('iframe[data-chat-src]');
    if (iframe && iframe.dataset.chatSrc && !iframe.src) {
      iframe.src = iframe.dataset.chatSrc;
    }
    
    var isMobile = window.innerWidth <= 768;
    var isOpen = chatWindow.style.display === "block";
    
    if (!isOpen) {
      // 打开窗口
      chatWindow.style.display = "block";
      chatBtn.classList.add("chat-open");
      
      // 移动端：阻止底层页面滚动和防止缩放
      if (isMobile) {
        // 保存当前滚动位置
        var scrollY = window.scrollY;
        body.style.position = 'fixed';
        body.style.top = '-' + scrollY + 'px';
        body.style.width = '100%';
        body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';
        html.style.maxWidth = '100vw';
        body.style.maxWidth = '100vw';
        
        // 保存滚动位置到 data 属性，以便恢复
        body.setAttribute('data-scroll-y', scrollY);
        
        // 防止 iOS Safari 自动缩放：动态修改 viewport
        var viewport = document.querySelector('meta[name="viewport"]');
        if (viewport) {
          viewport.setAttribute('data-original-content', viewport.getAttribute('content') || '');
          viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover');
        }
      }
    } else {
      // 关闭窗口
      chatWindow.style.display = "none";
      chatBtn.classList.remove("chat-open");
      
      // 移动端：恢复页面滚动和 viewport
      if (isMobile) {
        var scrollY = body.getAttribute('data-scroll-y') || '0';
        body.style.position = '';
        body.style.top = '';
        body.style.width = '';
        body.style.overflow = '';
        html.style.overflow = '';
        html.style.maxWidth = '';
        body.style.maxWidth = '';
        body.removeAttribute('data-scroll-y');
        
        // 恢复 viewport
        var viewport = document.querySelector('meta[name="viewport"]');
        if (viewport && viewport.hasAttribute('data-original-content')) {
          var originalContent = viewport.getAttribute('data-original-content');
          viewport.setAttribute('content', originalContent || 'width=device-width,initial-scale=1');
          viewport.removeAttribute('data-original-content');
        }
        
        // 恢复滚动位置
        window.scrollTo(0, parseInt(scrollY));
      }
    }
  }

  // 页面加载完成后显示按钮
  function showChatButton() {
    var chatBtn = document.getElementById("manual-chat-btn");
    if (chatBtn) {
      chatBtn.classList.add("loaded");
    }
  }
  
  // 等待页面完全加载完成
  if (document.readyState === 'complete') {
    // 如果已经加载完成，直接显示
    setTimeout(showChatButton, 100);
  } else {
    // 等待页面加载完成
    window.addEventListener('load', function() {
      setTimeout(showChatButton, 100);
    });
  }
  
  // 直接绑定事件，使用事件委托，不等待 DOM 加载
  // 使用事件委托，即使元素还没加载也能工作
  document.addEventListener('click', function(e) {
    var target = e.target;
    var chatBtn = document.getElementById("manual-chat-btn");
    
    // 检查点击的是按钮本身或按钮内的元素
    if (chatBtn && (target === chatBtn || chatBtn.contains(target))) {
      e.preventDefault();
      e.stopPropagation();
      toggleChatWindow();
    }
  }, true);
  
  // 监听窗口大小变化，如果从移动端切换到桌面端，确保恢复滚动和 viewport
  window.addEventListener('resize', function() {
    var chatWindow = document.getElementById("manual-chat-window");
    var body = document.body;
    var html = document.documentElement;
    
    if (chatWindow && chatWindow.style.display === "block") {
      var isMobile = window.innerWidth <= 768;
      if (!isMobile) {
        // 切换到桌面端时，恢复滚动和 viewport
        body.style.position = '';
        body.style.top = '';
        body.style.width = '';
        body.style.overflow = '';
        html.style.overflow = '';
        html.style.maxWidth = '';
        body.style.maxWidth = '';
        body.removeAttribute('data-scroll-y');
        
        // 恢复 viewport
        var viewport = document.querySelector('meta[name="viewport"]');
        if (viewport && viewport.hasAttribute('data-original-content')) {
          var originalContent = viewport.getAttribute('data-original-content');
          viewport.setAttribute('content', originalContent || 'width=device-width,initial-scale=1');
          viewport.removeAttribute('data-original-content');
        }
      }
    }
  });
})();

